import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import AddBox from '@material-ui/icons/AddBox';
import DeleteForever from '@material-ui/icons/DeleteForever';
import { ValidatorForm } from 'react-material-ui-form-validator';

import { createDocumentType, editDocumentTypeFields, getDocumentTypeById } from '../../store/actions';

import { DocumentTypesToGet_documentTypeFields, DocumentTypeFieldsToPost, DocumentTypesToGet } from '../../models/interfaces';
import { InputErrors } from '../../../../models/interfaces';

import theme from '../../../../styles/theme';
import { Container, ParagraphTitle, IButton, InputText, InputSelect, ButtonSend, styleError, TextError } from '../../../../styles/styles';

const INITIAL_Inputs: DocumentTypesToGet_documentTypeFields = {
  id: 0,
  description: '',
  fieldType: '',
  allowsNull: false,
  active: true,
};

const DocumentTypeCreate: React.FC = () => {
  const [NameTypeDocument, setNameTypeDocument] = useState<string>('');
  const [WarningDaysTypeDocument, setWarningDaysTypeDocument] = useState<number>(15);
  const [Inputs, setInputs] = useState<DocumentTypesToGet_documentTypeFields[]>([INITIAL_Inputs]);
  const [InputErrors, setInputErrors] = useState<InputErrors[]>([]);
  const [RequiredDescription, setRequiredDescription] = useState<boolean>(false);
  const [SendEmail, setSendEmail] = useState<boolean>(true);

  const { id } = useParams<{id: string}>();
  const history = useHistory();

  useEffect(() => {
    if (id) {
      getDocumentTypeById(parseInt(id))
        .then((res: { data: { documentType: DocumentTypesToGet } }) => {
          setNameTypeDocument(res.data.documentType.name);
          setWarningDaysTypeDocument(res.data.documentType.daysToDueNotice);
          setInputs(res.data.documentType.documentTypeFields);
          setRequiredDescription(res.data.documentType.requiredDescription);
          setSendEmail(res.data.documentType.sendEmail);
        })
    }
  }, [id]);

  const handleDocumentType = (event: React.ChangeEvent<HTMLSelectElement>, input: string) => {
    if(input === "name") {
      setNameTypeDocument(event.target.value);
    } else if(input === "warningDays") {
      setWarningDaysTypeDocument(parseInt(event.target.value));
    }
  }

  const handleAddedInput = () => {
    removeErrorsInput('fields');
    setInputs([...Inputs, INITIAL_Inputs]);
  }

  const handleRemoveInput = (index: number) => {
    if (!id || (id && typeof Inputs[index].documentTypeId === 'undefined')) {
      Inputs.splice(index, 1);
      setInputs([...Inputs]);
    } else {
      Inputs[index] = { ...Inputs[index], active: false };
      setInputs([...Inputs]);
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>, index: number, attr: string) => {
    Inputs[index] = { ...Inputs[index], [attr]: event.target.value };
    setInputs([...Inputs]);
  }

  const toggleChecked = (index: number) => {
    if(verifyInputError('requiredField') && Inputs[index].allowsNull === false) {
      removeErrorsInput('requiredField');
    }
    Inputs[index] = { ...Inputs[index], allowsNull: !Inputs[index].allowsNull };
   
    setInputs([...Inputs]);
  };

  const handleSubmit = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    event.preventDefault();

    if (verifyInputError()) {
      return;
    }

    const params: DocumentTypeFieldsToPost = {
      name: NameTypeDocument,
      active: true,
      documentTypeFields: Inputs,
      daysToDueNotice: WarningDaysTypeDocument,
      requiredDescription: RequiredDescription,
      sendEmail: SendEmail,
    };

    let textLoading = 'Cadastrando...';
    let textTitleSuccess = 'Tipo de Documento Criado';
    let textSuccess = 'foi criado com sucesso !';

    if (id) {
      textLoading = 'Editando...';
      textTitleSuccess = 'Tipo de Documento Editado';
      textSuccess = 'foi editado com sucesso !';
      params.id = id;
    }

    Swal.fire({
      title: 'Aguarde...',
      text: textLoading,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: async () => {
        Swal.showLoading();

        const res = !id ? await createDocumentType(params) : await editDocumentTypeFields(params);

        if (res) {
          Swal.fire({
            title: textTitleSuccess,
            html: `O Tipo de Documento <b>${params.name}</b> ${textSuccess}`,
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: theme.palette.primary.main,
            confirmButtonText: 'OK'
          });
        } else {
          Swal.fire({
            title: 'Erro',
            text: `Ocorreu algum erro ao executar a ação!`,
            icon: 'error',
            showConfirmButton: false,
            timer: 2000
          });
        }

        setInputs([INITIAL_Inputs]);
        setNameTypeDocument('');
        setInputErrors([]);

        history.push('/document-type/list');
      }
    });
  }

  const validateForm = () => {
    if (Inputs.filter(object => object.active !== false).length === 0) {
      if (InputErrors.findIndex(object => object.input === "fields") === -1) {
        setInputErrors([...InputErrors, { input: 'fields' }]);
      }
    }

    if (Inputs.findIndex(object => object.allowsNull === true) === -1) {
      if (InputErrors.findIndex(object => object.input === "requiredField") === -1) {
        setInputErrors([...InputErrors, { input: 'requiredField' }]);
      }
    }
  }

  const removeErrorsInput = (input: string) => {
    const index = InputErrors.findIndex(object => object.input === input);
    if(index !== -1) {
      InputErrors.splice(index, 1);
    }
  }

  const verifyInputError = (input?: string[] | string): Boolean => {
    var index: any;
    if(Array.isArray(input)) {
      input.forEach(element => {
         if(InputErrors.findIndex(object => object.input === element) !== -1) {
          index = true;
          return;
         }
      });
      if(!index) {
        index = -1;
      }
    } else {
      index = Boolean(input) ? InputErrors.findIndex(object => object.input === input) : InputErrors.length;
    }

    
    if ((Boolean(input) && index !== -1) || (!Boolean(input) && index > 0) || (index === true)) {
      return true;
    } else {
      return false;
    }
  }

  const inputItem = (element: DocumentTypesToGet_documentTypeFields, index: number) => {
    if (element.active) {
      return (
        <Grid container spacing={2} key={index}>
          <Grid item xs={6}>
            <InputText
              label="Nome"
              type="text"
              value={element.description}
              fullWidth
              variant="outlined"
              onChange={(e: any) => handleChange(e, index, 'description')}
              // validators={['required']}
              // errorMessages={['Campo obrigatório']}
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl variant="outlined" style={{ width: '100%' }}>
              <InputSelect
                label="Tipo"
                inputProps={{ 'aria-label': 'Without label' }}
                variant="outlined"
                value={element.fieldType}
                onChange={(e: any) => handleChange(e, index, 'fieldType')}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              >
                <MenuItem value={'text'}>Texto</MenuItem>
                <MenuItem value={'number'}>Número</MenuItem>
              </InputSelect>
            </FormControl>
          </Grid>
          <Grid item xs={2} style={{ display: 'flex', justifyContent: 'center' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={element.allowsNull}
                  color="primary"
                  onChange={() => toggleChecked(index)}
                />
              }
              label="Obrigatório"
            />
          </Grid>
          <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <DeleteForever
              style={{ fontSize: 30, marginLeft: 5, cursor: 'pointer', color: 'red' }}
              onClick={() => handleRemoveInput(index)}
            />
          </Grid>
        </Grid>
      )
    }
  }

  return (
    <React.Fragment>
      <Container background="#E2E4E6">
        <ValidatorForm onSubmit={(e: any) => handleSubmit(e)}>
          <Grid container spacing={2}>

            <Grid item xs={6}>
              <InputText
                label="Tipo de Documento"
                type="text"
                value={NameTypeDocument}
                autoFocus
                fullWidth
                variant="outlined"
                onChange={(e: any) => handleDocumentType(e, "name")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>

            <Grid item xs={3}>
              <InputText
                label="Aviso do Vencimento (dias)"
                type="text"
                value={WarningDaysTypeDocument}
                fullWidth
                variant="outlined"
                onChange={(e: any) => handleDocumentType(e, "warningDays")}
                validators={['required']}
                errorMessages={['Campo obrigatório']}
              />
            </Grid>
            <Grid item xs={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={RequiredDescription}
                    color="primary"
                    onChange={() => setRequiredDescription(RequiredDescription? false : true)}
                  />
                }
                label="Descrição obrigatória"
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={SendEmail}
                    color="primary"
                    onChange={() => setSendEmail(!SendEmail)}
                  />
                }
                label="Envio de E-mail obrigatório"
              />
            </Grid>
          </Grid>
          <Container background="#ECECEC" style={{ marginTop: '20px', ...verifyInputError(['fields', 'requiredField']) ? styleError : null }}>
            <ParagraphTitle>Campos do Formulário</ParagraphTitle>
            {Inputs.map((element, index) => {
              return inputItem(element, index);
            })}
            <AddBox
              color="primary"
              style={{ fontSize: 40, marginLeft: 5, cursor: 'pointer' }}
              onClick={handleAddedInput}
            />
          </Container>
          {verifyInputError('requiredField') &&
            <TextError>Pelo menos 1 (um) campo deve ser obrigatório</TextError>
          }
          <ButtonSend>
            <IButton width={130} background="#26B2D1" type="button" style={{ marginRight: 10 }} onClick={() => { history.goBack(); }}>VOLTAR</IButton>
            <IButton width={130} background="#52D126" type="submit" onClick={validateForm}>
              {!id ? 'CADASTRAR' : 'EDITAR'}
            </IButton>
          </ButtonSend>
        </ValidatorForm>
      </Container>
    </React.Fragment>
  )
}

export default DocumentTypeCreate;
